import React from 'react';
import { Grid, styled } from '@mui/material';
import { Colors } from 'library';

export default function HowItWorkCard({ children }: { children: React.ReactNode }) {
    return (
        <Card item lg={4} md={6} sm={12} xs={12}>
            <Container>{children}</Container>
        </Card>
    );
}

const Card = styled(Grid)({
    padding: 5,
});

const Container = styled('div')({
    backgroundColor: Colors.white,
    borderRadius: 10,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    height: 500,
    maxHeight: 500,
    width: '100%',
});
